import { AxiosError } from 'axios';
import useApi from 'hooks/useApi';
import useAuthToken from 'hooks/useAuthToken';
import { BackendError } from 'models/backend-error';
import { useEffect, useMemo, useState } from 'react';
import redirectToAuth from 'utilities/redirectToAuth';

const useStudentWebinarConversationId = ({ webinarId }: { webinarId: string }): string | null => {
  const [ conversationId, setConversationId ] = useState<string | null>(null);

  const { getAuthToken, removeAuthToken } = useAuthToken();
  const authToken = useMemo<string | null>(() => getAuthToken() ?? null, [ getAuthToken ]);

  const api = useApi();

  useEffect(() => {
    if (authToken) {
      api.request<{ conversationId: string }>({
        method: 'GET',
        url: `student/webinars/${webinarId}/chat`,
        headers: {
          authorization: `Bearer ${authToken}`,
        },
      }).then(({ data }) => {
        setConversationId(data.conversationId);
      }).catch((error: AxiosError<BackendError>) => {
        if (error.response?.status === 401) {
          removeAuthToken();
          redirectToAuth();
        }
      });
    } else {
      redirectToAuth();
    }
  }, [ webinarId ]);

  return conversationId;
};

export default useStudentWebinarConversationId;
